import "vite/modulepreload-polyfill";
import { createRoot } from "react-dom/client";
import { TableWidget } from "../osoigonext_core/Components/Table.jsx";
import { FileList } from "./Components/FileList.jsx";

export function RenderFileList(configuration){
    const container = document.getElementById(configuration.container);
    const root = createRoot(container);

    root.render(
      (
        <FileList configuration={configuration}></FileList>
      ),
    );
}

document.addEventListener("DOMContentLoaded", function() {
    const widget_configs = document.querySelectorAll(".file-list-widget-config");

    for (let config of widget_configs) {
        RenderFileList(JSON.parse(config.innerText));
    }
});
